import { format, parseJSON } from "date-fns";

function formatUTC(date: Date) {
  try {
    return date.toISOString().replace("T", " ").replace("Z", " UTC");
  } catch {
    return "Invalid Date";
  }
}

type TimestampProps = {
  timestamp: string;
  localized?: boolean;
};
const Timestamp = ({ timestamp, localized = true }: TimestampProps) => {
  const date = parseJSON(timestamp);
  const display = localized ? format(date, "yyyy-MM-dd HH:mm:ss.SSS z") : formatUTC(date);

  return <span className="truncate rounded-sm bg-gray-100 px-2 py-0.5 font-mono text-xs text-gray-600">{display}</span>;
};

export default Timestamp;
